import { Link } from '@remix-run/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import PlentyBody from '#app/components/typography/plenty-body.tsx'
import { Icon } from '#app/components/ui/icon.tsx'

interface BreadcrumbShopTheLookProps {
	name?: string
	gender: any
	type: string
}

const BreadcrumbShopTheLook: React.FC<BreadcrumbShopTheLookProps> = ({
	name,
	gender,
	type,
}) => {
	let { t } = useTranslation('shop_the_look')

	const formattedPascalGender =
		gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase()

	const formattedLowerGender = gender.toLowerCase()

	switch (type) {
		case 'plp':
			return (
				<div className="flex flex-row space-x-2 pb-4 md:pb-2">
					<div className="flex flex-row items-center">
						<Link to={`/${formattedLowerGender}-landing`}>
							<PlentyBody size="xs">{formattedPascalGender}</PlentyBody>
						</Link>
						<Icon name="slash" size="sm" />
					</div>
					<div className="flex flex-row items-center">
						<Link to={`/shop-the-look?gender=${formattedPascalGender}`}>
							<PlentyBody size="xs">{t('shop_the_look')}</PlentyBody>
						</Link>
					</div>
				</div>
			)
		case 'pdp':
			return (
				<div className="flex flex-row space-x-2 pb-2 md:pb-4">
					<div className="flex flex-row items-center">
						<Link to={`/${formattedLowerGender}-landing`}>
							<PlentyBody size="xs">{formattedPascalGender}</PlentyBody>
						</Link>
						<Icon name="slash" size="sm" />
					</div>
					<div className="flex flex-row items-center">
						<Link to={`/shop-the-look?gender=${formattedPascalGender}`}>
							<PlentyBody size="xs">{t('shop_the_look')}</PlentyBody>
						</Link>
						<Icon name="slash" size="sm" />
					</div>
					<div className="flex items-center">
						<PlentyBody size="xs">{name}</PlentyBody>
					</div>
				</div>
			)
	}
}

export default BreadcrumbShopTheLook
